export default __webpack_public_path__ + "static/media/step_1_image_.131316bb.png";